const  en = {
  description: "We inspire influencers"
}
export default en;
